import { WorkflowPage } from './workflow-page.model';

export class WorkflowTemplate {
    public readonly name: string;
    public readonly pages: WorkflowPage[];

    private _costCenterId: number;
    private _shiftBlockId: number;
    private _workflowTimeFacility: string; 

    public constructor(private fields?: Partial<WorkflowTemplate>) {
        // Normally, this would use Object.assign(this, fields); however, 
        // internet explorer doesn't support it so properties are explicitly assigned instead.     
        if (fields) {

            this.name = fields.name ? fields.name : "";
            this.pages = fields.pages ? fields.pages : [];
        }
    }

    get costCenterId(): number {
        return this._costCenterId;
    }

    get shiftBlockId(): number {
        return this._shiftBlockId;
    }

    get workflowTimeFacility(): string {
        return this._workflowTimeFacility;
    }

    set costCenterId(value: number) {
        this._costCenterId = value;
    }

    set shiftBlockId(value: number) {
        this._shiftBlockId = value;
    }

    set workflowTimeFacility(value: string) {
        this._workflowTimeFacility = value;
    }
}